import styled from "styled-components";
import { GrayColors } from "@smartsuite/types";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-left: 10px;
  height: 35px;
  border: 1px solid ${GrayColors["G-1-5"]};
  padding: 0 10px;

  border-radius: 6px;
  cursor: pointer;
  transition: border-color 100ms ease-out;

  &:hover {
    transition: border-color 200ms ease-in;
    border-color: ${GrayColors["G-3"]};
  }
`;
